import { render, staticRenderFns } from "./comanyQuality.vue?vue&type=template&id=5b9cdc60&scoped=true&"
import script from "./comanyQuality.vue?vue&type=script&lang=js&"
export * from "./comanyQuality.vue?vue&type=script&lang=js&"
import style0 from "./comanyQuality.vue?vue&type=style&index=0&id=5b9cdc60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9cdc60",
  null
  
)

export default component.exports